import { useState } from "react";
import Button from "../../../../components/Button";
import Modal from "../../../../components/modals/Modal";
import Loading from "../../../../components/loading/Loading";
import { firestore } from "../../../../firebase/config";
import { arrayUnion, doc, updateDoc } from "firebase/firestore";

const AddMockPlayers = ({ tournamentId, playerIds }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [numberOfMockPlayers, setNumberOfMockPlayers] = useState(12);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const writeMockPlayers = async () => {
    const tournamentRef = doc(firestore, "tournaments", tournamentId);
    setIsLoading(true);

    const mockPlayers = [];

    for (let i = 0; i < numberOfMockPlayers; i++) {
      mockPlayers.push(`PLAYER ${i + 1 + playerIds?.length}`);
    }

    try {
      await updateDoc(tournamentRef, { playerIds: arrayUnion(...mockPlayers) });

      setIsLoading(false);
      setIsModalOpen(false);
    } catch (error) {
      alert(`ERROR: ${error.message}`);
    }
  };

  return (
    <>
      <Button color="green" onClick={handleToggleModal}>
        Add Mock Players
      </Button>

      <Modal
        isOpen={isModalOpen}
        onCancel={handleToggleModal}
        onConfirm={writeMockPlayers}
        title={"Add Mock Players"}
        subtitle={"This will add fake players to the tournamnent"}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <div>
            <label
              className="text-lg font-medium text-gray-800"
              htmlFor="player-count"
            >
              Number of players:
            </label>
            <select
              id="player-count"
              defaultValue={numberOfMockPlayers}
              onChange={(e) => setNumberOfMockPlayers(Number(e.target.value))}
              className="ml-2"
            >
              {[...Array(24)].map((_, i) => {
                const value = i + 1;
                return (
                  <option key={value} value={value}>
                    {value}
                  </option>
                );
              })}
            </select>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AddMockPlayers;
